import ArtifactFieldset from '@/features/artifacts/components/ArtifactForm/ArtifactFieldset';
import styled from 'styled-components';

export const CustomArtifactFieldset = styled(ArtifactFieldset)`
  div {
    flex: 1 1 100%;
  }
`;
